<template>
  <reg-card>
    <div class="card-icon">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="#ff825d"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
    </div>
    <h2 class="title">Número de cartões</h2>
    <p class="sub">Selecione um add-on para aumentar o plafond (opcional)</p>

    <div class="addon-list">
      <button
        v-for="opt in opcoes" :key="opt.id"
        class="addon-btn"
        :class="{ selected: selecionado === opt.id }"
        @click="selecionado = selecionado === opt.id ? null : opt.id"
      >
        <span class="addon-label">{{ opt.label }}</span>
        <span class="addon-preco">{{ opt.preco_mensal }}€/mês</span>
      </button>

      <button class="addon-btn addon-none" :class="{ selected: selecionado === null }" @click="selecionado = null">
        Nenhum
      </button>
    </div>

    <p v-if="selecionado" class="addon-hint">
      Inclui {{ notificacoesIncluidas.toLocaleString("pt-PT") }} notificações semanais adicionais
    </p>

    <button class="btn-dark" @click="$emit('done', selecionado)">AVANÇAR</button>
  </reg-card>
</template>

<script>
import RegCard from "../components/RegCard.vue";

export default {
  name: "OStep2",
  components: { RegCard },
  props: {
    opcoes: { type: Array, default: () => [] },
    value:  { default: null },
  },
  data() {
    return { selecionado: this.value };
  },
  computed: {
    notificacoesIncluidas() {
      const opt = this.opcoes.find(o => o.id === this.selecionado);
      return opt?.notificacoes_incluidas || 0;
    },
  },
};
</script>

<style scoped lang="scss">
.card-icon  { width: 36px; height: 36px; background: #fff5f0; border-radius: 10px; display: flex; align-items: center; justify-content: center; margin-bottom: 12px; }
.title      { font-size: 22px; font-weight: 800; color: #1a1210; margin-bottom: 4px; }
.sub        { font-size: 13px; color: #b0a8a0; margin-bottom: 14px; }
.addon-list { display: flex; flex-direction: column; gap: 8px; margin-bottom: 8px; }
.addon-btn  {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 16px; border: 1.5px solid #e8e4e0; border-radius: 10px;
  background: #fff; cursor: pointer; font-family: inherit; transition: all .15s;
  &:hover { border-color: #ff825d; }
  &.selected { border-color: #ff825d; background: #ff825d;
    .addon-label, .addon-preco { color: #fff; }
  }
  &.addon-none { justify-content: center; color: #b0a8a0; font-size: 14px; font-weight: 600; }
  &.addon-none.selected { border-color: #e8e4e0; background: #f7f4f1; color: #7a736e; }
}
.addon-label { font-size: 14px; font-weight: 600; color: #1a1210; }
.addon-preco { font-size: 13px; color: #b0a8a0; }
.addon-hint  { font-size: 12px; color: #ff825d; font-weight: 500; margin-bottom: 4px; text-align: center; }
.btn-dark { display: flex; align-items: center; justify-content: center; width: 100%; height: 50px; border: none; border-radius: 10px; background: #1a1210; color: #fff; font-size: 14px; font-weight: 700; cursor: pointer; font-family: inherit; margin-top: 12px; &:hover { background: #2d2420; } }
</style>
